import styled from '@emotion/styled'

export const HeaderPillStyled = styled.span({
  backgroundColor: 'rgba(0,0,0,0.5)',
  lineHeight: 1.2,
  padding: '0.3rem 0.7rem',
  boxSizing: 'border-box',
  borderRadius: '10rem',
  display: 'inline-block',
})

export const MarketPillStyled = styled(HeaderPillStyled)({
  display: 'inline-flex',
  alignItems: 'center',
  fontWeight: 'bold',
  marginLeft: '-0.7rem',
  maxWidth: 'fit-content',
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  marginTop: '0.1rem',
})

export const MarketNameStyled = styled.span({
  display: 'inline-block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal',
})

export const MarketTypeStyled = styled.span({
  paddingLeft: '0.3rem',
  minWidth: '3.5rem',
  flexGrow: 1,
  textAlign: 'right',
  textTransform: 'uppercase',
})

export const CompetitionAndTournamentStyled = styled.div({
  display: 'inline-block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal',
  width: 'calc(100% - 2.5rem)',
  fontSize: '1.4rem',
  fontWeight: 'bold',
  lineHeight: 1.3,
  paddingBottom: '0.2rem',
})

export const SingleSelectionStyled = styled.div({
  fontSize: '1.8rem',
  fontWeight: 'bold',
  lineHeight: 'normal',
  padding: '1rem 0 0',
  wordBreak: 'break-word',
  hyphens: 'auto',
})

export const EventStyled = styled.div({
  display: 'inline-block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal',
  width: 'calc(100% - 2.5rem)',
  fontSize: '1.2rem',
  lineHeight: 1,
})
